import React, { useContext, useState } from "react";
import styles from "./upgrade.module.scss";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import AuthContext from "../../../hooks/authContext";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Button, Dialog, DialogActions, DialogContent, Divider, Typography  } from "@material-ui/core";
import { useNavigate } from "react-router";
import { Shield, CreditCard, Landmark } from "lucide-react";
import PaymentSuccess from "./PaymentSuccess";
import {
  useStripe,
  useElements,
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  // CardElement,
} from "@stripe/react-stripe-js";
import {
  getCardDetails,
  getBankAccountDetails,
  PaymentFailedEmail,
  saveCardDetails,
  // sendEmailForAchPaymentDetail,
  savePaymentDetailsForVerification,
  finalizeFreeSubscription,
  savePromoCode,
} from "../../../services/apiservices/users";
import { US_STATES } from "../../../components/USStateConstant";
import { useToast } from "../../../hooks/useToast";
import { CommonSuccessDialog } from "../../../components/DialogComponent/SupplyDataDialog";
// import ACHVerification from "./ACHverification";

const PaymentFlowContet = (props) => {
  const {
    plan,
    loader,
    setName,
    name,
    // handleSubmit,
    newPrice,
    newAmounts,
    setClientSecret,
    clientSecret,
    handleQuantityStripeSubscription,
    setNumUsers,
    numUsers,
    priceState,
    paymentSuccess,
    setPaymentSuccess,
    handleNavigate,
    setLoader,
    newPriceId,
    setNewPriceId,
    code,
    isFullDiscount,
    newProduct
  } = props;

  const auth = useContext(AuthContext);
  const { toast } = useToast();
  const stripe = useStripe();
  const elements = useElements();
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("card");
  const [achDetails, setAchDetails] = useState({
    routingNumber: "",
    accountNumber: "",
    accountType: "checking",
    accountHolderName: "",
  });
  const [temptError, setTemptError] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    cardNumber: "",
    cardExpiry: "",
    cardCvc: "",
    routingNumber: "",
    accountNumber: "",
    accountHolderName: "",
  });
  const isDarkMode = localStorage?.getItem('darkMode') === 'true';
  const [paymentErrorPopup, setPaymentErrorPopup] = useState({open: false, message:""});
  const [postalCode, setPostalCode] = useState("");
  const [messageDialog, setMessageDialog] = useState(false);
  const status = auth?.userProfile?.subscriptionDetails?.status;
  const newPaymentMethod = auth?.userProfile?.pendingVerifications?.length > 0 && auth?.userProfile?.pendingVerifications?.[0]?.status === "pending" ? "ach" : paymentMethod;
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const getDaysUsed = (currentPeriodStart) => {
    const now = new Date();
    const start = new Date(currentPeriodStart * 1000);

    const diffTime = now - start;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  const getFriendlyStripeErrorMessage = (error) => {
    const code = error?.code;

    const messages = {
      incorrect_zip: "The ZIP code you entered seems incorrect. Please check and try again.",
      invalid_number: "The card number you entered is not valid. Please check the number and try again.",
      invalid_expiry_month: "Please enter a valid expiry month for your card.",
      invalid_expiry_year: "Please enter a valid expiry year for your card.",
      invalid_cvc: "The security code (CVC) you entered is not valid. Please try again.",
      incorrect_cvc: "The security code (CVC) you entered does not match. Please double-check and try again.",
      expired_card: "This card has expired. Please use a different card.",
      authentication_required: "This payment requires additional verification. Please follow the steps to complete the payment.",
      card_declined: "Your payment transaction failed. Please check your information and try again.",
      insufficient_funds: "There are insufficient funds in this account. Please use another payment method.",
      processing_error: "Something went wrong while processing the payment. Please try again.",
      incorrect_address: "The address you entered does not match the card's billing address. Please check your details.",
      incorrect_number: "The card number you entered is incorrect. Please verify and try again.",
      bank_account_unverified: "Your bank account is not verified. Please verify it before making a payment.",
      bank_account_unusable: "This bank account cannot be used for payments. Please use a different account.",
      bank_account_restricted: "This bank account has restrictions and cannot be used for payments. Please try another account.",
      bank_account_closed: "This bank account has been closed. Please use a different account.",
      bank_account_exists: "This bank account is already added.",
      instant_payouts_unsupported: "This bank does not support instant payments. Please use another method.",
      payment_intent_authentication_failure:
        "Your bank could not complete the authentication. Please try again.",
      payment_intent_unexpected_state:
        "The payment could not be completed due to a bank issue. Please try again.",
      us_bank_account_verification_failed:
        "We could not verify your bank account. Please check your bank details and try again.",
      parameter_invalid_empty:
        "Some required bank information is missing. Please fill in all fields.",
      account_number_invalid: "The bank account number you entered is invalid. Please check and try again.",
      routing_number_invalid: "The routing number you entered is invalid. Please check and try again.",
      default: "Payment failed. Please check your details and try again."
    };

    return messages[code] || error?.message || messages.default;
  };

  const start =
    auth?.userProfile?.subscriptions?.data?.[0]?.current_period_start;
  // eslint-disable-next-line no-unused-vars
  const daysUsed = getDaysUsed(start);
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();

  const handleNavigateBack = () => {
    setClientSecret(null);
    window.location.reload();
  };

  const formatStripeAmount = (amount) => {
    const safeAmount = Number(amount) || 0;
    return `$${(safeAmount / 100).toFixed(0)}`;
  };
  const plansDetail = plan?.find((item) => item.id === newPrice);
  const price = priceState?.[plansDetail?.product?.name]?.yearly;

  const baseAmount = plansDetail?.unit_amount || 0;
  const actualAmountToPay = clientSecret?.amountToPay ?? newAmounts ?? 0;

  // eslint-disable-next-line no-unused-vars
  const creditAmount = baseAmount - actualAmountToPay;

  const yearlyTotalDays = 365;
  const remainingDays = yearlyTotalDays - clientSecret?.daysUsed;

  const creditAmounts =
    clientSecret?.creditFromOldPlan - clientSecret?.creditFromOldSubscription;

  const handlePaymentError = async (errorMessage) => {
    const formData = {
      email: auth?.userProfile?.email,
      name: auth?.userProfile?.firstName,
      companyName: `${auth?.userProfile?.companyName}`
    };

    const message = paymentMethod === "ach" ? "Unfortunately, this bank transaction has failed. Please check your information and try again. If the payment fails again please contact your banking institution." : errorMessage

    await PaymentFailedEmail(formData, paymentMethod);
     setLoader(false);

    toast?.({
      title: "Payment failed",
      description: message || "Payment failed! Please try again.",
      variant: "destructive"
    })
    setTemptError(true);
    setPaymentErrorPopup({
      open: true,
      message: message || "Something went wrong while processing your payment.",
    });
  };

  const handleCloseDialog = () => {
    setPaymentErrorPopup({
      open: false,
      message: "",
    });
  };

  const resetForm = () => {
    setLoader(false);
    setAddress("");
    setCity("");
    setPostalCode("");
    setState("");
    setNewPriceId();
  };

  const handleStripeFieldErrors = (error) => {
    const newErrors = {};

    if (error.code === "invalid_number" || error.code === "incorrect_number" || error.code === "card_declined" || error.param === "card[number]") {
      newErrors.cardNumber = error.message;
    }

    if (error.code === "invalid_expiry_month" || error.code === "invalid_expiry_year" || error.param === "card[exp]") {
      newErrors.cardExpiry = error.message;
    }

    if (error.code === "invalid_cvc" || error.code === "incorrect_cvc" ||error.param === "card[cvc]") {
      newErrors.cardCvc = error.message;
    }

    if (error.code === "routing_number_invalid" || error.param === "us_bank_account[routing_number]") {
      newErrors.routingNumber = error.message;
    }

    if (error.code === "account_number_invalid" || error.param === "us_bank_account[account_number]") {
      newErrors.accountNumber = error.message;
    }

    if (error.param === "billing_details[name]") {
      newErrors.accountHolderName = error.message;
    }

    setErrors((prev) => ({ ...prev, ...newErrors }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    if (code && isFullDiscount) {
      let setupIntent;

      if (paymentMethod === "card") {
        const cardElement = elements.getElement(CardNumberElement);

        const result = await stripe.confirmCardSetup(clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: auth?.userProfile?.firstName,
              email: auth?.userProfile?.email,
            },
          },
        });

        if (result.error) {
          handleStripeFieldErrors(result.error);
          await handlePaymentError(getFriendlyStripeErrorMessage(result.error));
          return;
        }

        setupIntent = result.setupIntent;
      } else if (paymentMethod === "ach"){
        const pmResult = await stripe.confirmUsBankAccountSetup(
          clientSecret,
          {
            payment_method: {
              us_bank_account: {
                routing_number: achDetails.routingNumber,
                account_number: achDetails.accountNumber,
                account_holder_type: "individual",
                account_type: achDetails.accountType,
              },
              billing_details: {
                name: achDetails.accountHolderName,
                email: auth?.userProfile?.email,
                address: {
                  line1: address,
                  city,
                  state,
                  postal_code: postalCode,
                },
              },
            },
          }
        );

        if (pmResult.error) {
          handleStripeFieldErrors(pmResult.error);
          await handlePaymentError(getFriendlyStripeErrorMessage(pmResult.error));
          return;
        }

        setupIntent = pmResult.setupIntent;

        if (setupIntent.status === "requires_action" && setupIntent.next_action?.type === "verify_with_microdeposits") {

          const isDevOrStage = process.env.REACT_APP_ENV !== "prod";
          const realType = setupIntent?.next_action?.verify_with_microdeposits?.microdeposit_type;

          const verificationType = isDevOrStage ? "microdeposit" : realType === "descriptor_code" ? "descriptor_code" : "microdeposit";

          const userId = auth?.userProfile?.id;
          const setUpIntentId = setupIntent.id;
          const paymentIntentId = setupIntent.id;
          const subscriptionId = auth?.userProfile?.subscriptionDetails?.id || auth?.userProfile?.subscriptions?.data?.[0]?.id;
          savePaymentDetailsForVerification(paymentIntentId, verificationType, userId, newPriceId, newAmounts, setUpIntentId, subscriptionId, newProduct);
          savePromoCode(code, userId);
          setMessageDialog(true);

          setLoader(false);
          return;
        }
      }

      const details =
        paymentMethod === "card"
          ? await getCardDetails(setupIntent?.id)
          : await getBankAccountDetails(setupIntent);

      const cardOrBankDetails = {
        ...details,
        customer: auth?.userProfile?.customer,
      };

      const formData = {
        email: auth?.userProfile?.email,
        name: auth?.userProfile?.firstName,
      };

      const subscriptionId =
        auth?.userProfile?.subscriptionDetails?.id ||
        auth?.userProfile?.subscriptions?.data?.[0]?.id;
      
      const paymentMethodType = paymentMethod;
      const userId = auth?.userProfile?.id;

      await finalizeFreeSubscription(
        cardOrBankDetails,
        formData,
        subscriptionId,
        newPriceId,
        newProduct,
        setupIntent.id,
        paymentMethodType,
        code,
        userId
      );
      await delay(3000);
      resetForm();
      setPaymentSuccess(true);
    } else {
    try {
      let paymentIntent;

      if (paymentMethod === "card") {
        const result = await stripe.confirmCardPayment(
          clientSecret?.clientSecret,
          {
            payment_method: {
              card: elements.getElement(CardNumberElement),
              billing_details: {
                name,
                address: {
                  line1: address,
                  city,
                  state,
                  postal_code: postalCode,
                },
              },
            },
          }
        );

        if (result.error) {
          handleStripeFieldErrors(result.error);
          await handlePaymentError(getFriendlyStripeErrorMessage(result.error));
          return;
        }

        paymentIntent = result.paymentIntent;
      } else if (paymentMethod === "ach") {
        const pmResult = await stripe.createPaymentMethod({
          type: "us_bank_account",
          us_bank_account: {
            routing_number: achDetails.routingNumber,
            account_number: achDetails.accountNumber,
            account_holder_type: "individual",
            account_type: achDetails.accountType,
          },
          billing_details: {
            name: achDetails.accountHolderName,
            email: auth?.userProfile?.email,
            address: {
              line1: address,
              city,
              state,
              postal_code: postalCode,
            },
          },
        });

        if (pmResult.error) {
          handleStripeFieldErrors(pmResult.error);
          await handlePaymentError(getFriendlyStripeErrorMessage(pmResult.error));
          return;
        }

        const result = await stripe.confirmUsBankAccountPayment(
          clientSecret?.clientSecret,
          {
            payment_method: pmResult.paymentMethod.id,
          }
        );

        if (result.error) {
          console.error("ACH confirm error", result.error.message);
          handleStripeFieldErrors(result.error);
          await handlePaymentError(getFriendlyStripeErrorMessage(result.error));
          return;
        }

        paymentIntent = result.paymentIntent;
         
        if (paymentIntent.status === "requires_action" && paymentIntent.next_action?.type === "verify_with_microdeposits") {

          const isDevOrStage = process.env.REACT_APP_ENV !== "prod";
          const realType = paymentIntent?.next_action?.verify_with_microdeposits?.microdeposit_type;

          const verificationType = isDevOrStage ? "microdeposit" : realType === "descriptor_code" ? "descriptor_code" : "microdeposit";

          const userId = auth?.userProfile?.id;
          const paymentIntentId = paymentIntent.id;
          savePaymentDetailsForVerification(paymentIntentId, verificationType, userId, newPriceId, newAmounts);
          setMessageDialog(true);

          setLoader(false);
          return;
        }
      }

      const paymentMethodId = paymentIntent?.payment_method;

      const details =
        paymentMethod === "card"
          ? await getCardDetails(paymentIntent?.id)
          : await getBankAccountDetails(paymentIntent);

      const cardOrBankDetails = {
        ...details,
        customer: auth?.userProfile?.customer,
      };

      const formData = {
        email: auth?.userProfile?.email,
        name: auth?.userProfile?.firstName,
      };

      const subscriptionId =
        auth?.userProfile?.subscriptionDetails?.id ||
        auth?.userProfile?.subscriptions?.data?.[0]?.id;

      const paymentMethodType = paymentMethod;
      const userId = auth?.userProfile?.id;

      await saveCardDetails(
        cardOrBankDetails,
        formData,
        subscriptionId,
        newPriceId,
        newAmounts,
        paymentMethodId,
        paymentMethodType,
        code,
        userId
      );
      await delay(3000);
      resetForm();
      setPaymentSuccess(true);
    } catch (error) {
      console.error("Payment exception:", error);
      await handlePaymentError(getFriendlyStripeErrorMessage(error));
    }
  }  
};

  const handleCloseMessageDialog = () => {
    setMessageDialog(false); 
    resetForm();
    setPaymentSuccess(false);
    setNewPriceId();
    auth?.setsubstatus(false);
    window.location.reload();
  };

  return (
    <>
      {paymentSuccess === false ? (
        <>
          {plansDetail?.product?.name !== "Users Plan" ? (
            <div
              className={`${styles.container} dark:bg-[#1A1F2C] dark:text-white`}
            >
              <div className={styles.wrapper}>
                {/* Header */}
                <div className="mb-15 d-flex flex-justify-center">
                  <Button
                    onClick={handleNavigateBack}
                    className="pl-0 dark:text-white"
                  >
                    <span
                      style={{ color: "#6B7280" }}
                      className="d-flex flex-center"
                    >
                      {" "}
                      <KeyboardBackspaceIcon
                        className="mr-8 dark:text-white"
                        fontSize="small"
                      />
                      Back to Plans
                    </span>
                  </Button>
                </div>

                <div className={styles.header}>
                  <h2 className={`${styles.pageTitle} dark:text-white`}>
                    Complete your purchase
                  </h2>
                  <p className={styles.pageSubTitle}>
                    You're about to subscribe to the{" "}
                    {plansDetail?.product?.name}
                  </p>
                </div>
                {/* Grid Layout */}
                <div className={styles.grid}>
                  {/* Order Summary */}
                  <div
                    className={`${styles.card} dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] `}
                  >
                    <div className={styles.cardHeader}>Order Summary</div>
                    <div className={styles.cardContent}>
                      <div className={styles.data}>
                        <div className={styles.dataHeader}>
                          <div className={styles.planInfo}>
                            <p className={styles.newPlanText}>New Plan</p>
                            <p className={`${styles.planName} dark:text-white`}>
                              {plansDetail?.product?.name}
                            </p>
                            {status !== "trialing" && (
                              <span className={styles.upgradeBadge}>
                                <ArrowUpwardOutlinedIcon
                                  fontSize="small"
                                  className={styles.upgradeIcon}
                                />
                                Upgrade
                              </span>
                            )}
                          </div>
                          <p className={`${styles.planAmount} dark:text-white`}>
                            {formatStripeAmount(plansDetail?.unit_amount)}
                          </p>
                        </div>

                        <div
                          className={`${styles.adjustments} dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] `}
                        >
                          <h4
                            className={`${styles.adjustmentsTitle} dark:text-white`}
                          >
                            Billing Adjustments
                          </h4>

                          {status === "trialing" ? (
                            <p className={styles.adjustmentText}>
                              Your first payment will be{" "}
                              {formatStripeAmount(plansDetail?.unit_amount)}.
                              {plansDetail?.recurring?.interval === "year" &&
                                " This reflects annual billing with a 16.67% discount applied."}
                            </p>
                          ) : (
                            <div className={styles.adjustmentDetails}>
                              <p className={styles.adjustmentText}>
                                Today, you'll get a pro-rated charge for the
                                days remaining in this billing cycle. Starting
                                from your next billing cycle, your account will
                                be charged the full cost of your new
                                subscription plan.
                              </p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className={styles.orderRow}>
                        <span className={`${styles.planName} dark:text-white`}>
                          {plansDetail?.product?.name}
                        </span>
                        <span className="dark:text-white text-[#020817]">
                          {formatStripeAmount(plansDetail?.unit_amount)}
                        </span>
                      </div>

                      <div className={styles.billingCycle}>
                        <div className={styles.label}>Billing Cycle</div>
                        <div
                          className={`${styles.value} text-[#020817] dark:text-[#6B7280]`}
                        >
                          {plansDetail?.recurring?.interval === "month"
                            ? "Monthly"
                            : "Annual (Save 16.67%)"}
                        </div>
                      </div>

                      {status !== "trialing" && (
                        <div
                          style={{
                            fontFamily: "Arial, sans-serif",
                            maxWidth: "500px",
                            margin: "25px auto",
                            border: "1px solid #eee",
                            padding: "20px",
                            borderRadius: "8px",
                          }}
                        >
                          <h2
                            style={{
                              fontSize: "16px",
                              marginBottom: "8px",
                              fontWeight: "600",
                              color: "#28a745",
                            }}
                          >
                            Payment Summary
                          </h2>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                              marginTop: "10px",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Plan:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {formatStripeAmount(plansDetail?.unit_amount)}{" "}
                              {plansDetail?.recurring?.interval === "month"
                                ? "/month"
                                : "/year"}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Days Used:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {clientSecret?.daysUsed || 0}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Days Remaining:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {plansDetail?.recurring?.interval === "month"
                                ? (clientSecret?.daysRemaining ?? 0)
                                : (remainingDays ?? 0)}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Credits:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {formatStripeAmount(creditAmounts)}
                            </span>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              New Plans:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {formatStripeAmount(clientSecret?.amountToPay ? clientSecret?.amountToPay : clientSecret?.costForNewPlan)}{" "}
                            </span>
                          </div>

                          <hr style={{ margin: "15px 0" }} />

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontWeight: "bold",
                            }}
                          >
                            <span
                              className="dark:text-white text-[#020817]"
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              Total Due Now:
                            </span>
                            <span
                              style={{
                                fontWeight: "600",
                                color: "#6B7280",
                                fontSize: "14px",
                              }}
                            >
                              {!clientSecret?.amountToPay
                                ? `${formatStripeAmount(
                                    clientSecret?.finalAmountDue
                                  )}`
                                : `${formatStripeAmount(
                                    clientSecret?.amountToPay
                                  )}`}
                            </span>
                          </div>
                        </div>
                      )}

                      <div className={styles.totalSection}>
                        <div className={styles.totalRow}>
                          <span
                            className={`${styles.totalLabel} dark:text-white`}
                          >
                            Total
                          </span>
                          <span
                            className={`${styles.totalPrice} dark:text-white`}
                          >
                            {status === "trialing"
                              ? `${formatStripeAmount(
                                  plansDetail?.unit_amount
                                )}`
                              : !clientSecret?.amountToPay
                              ? `${formatStripeAmount(
                                  clientSecret?.finalAmountDue
                                )}`
                              : `${formatStripeAmount(
                                  clientSecret?.amountToPay
                                )}`}
                          </span>
                        </div>
                        <div className={styles.billingNote}>Billed Today</div>
                      </div>

                      <div className={styles.featuresList}>
                        <div
                          className={`${styles.featureHeader} dark:text-white`}
                        >
                          Plan includes:
                        </div>
                        {plansDetail?.product?.marketing_features?.map(
                          (feature, i) => (
                            <div key={i} className={styles.featureItem}>
                              <CheckOutlinedIcon
                                className={styles.featureIcon}
                              />
                              <span className="dark:text-white">
                                {feature?.name}
                              </span>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className={`${styles.card} dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
                  >
                    <div className={styles.cardHeader}>Payment Details</div>

                    <div className="d-flex flex-center flex-justify-center p-15">
                      <div
                        style={{
                          backgroundColor: "#F1F5F9",
                          padding: "10px",
                          borderRadius: "8px",
                        }}
                      >
                        <CreditCardOutlinedIcon
                          fontSize="large"
                          style={{ color: "blue" }}
                        />
                      </div>
                    </div>

                    {temptError && (
                      <div className="text-[16px] text-md small error color-danger mv-8 ml-14">Payment failed. Please verify your details and try again.</div>
                    )}

                    <form
                      onSubmit={handleSubmit}
                      className="space-y-6 w-full max-w-md mx-auto"
                    >
                      {/* Payment Method Selection */}
                      <div className="space-y-3">
                        <label className="text-sm font-medium">
                          Payment Method
                        </label>
                        <div className="flex bg-gray-100 rounded p-1">
                          <button
                            type="button"
                            onClick={() => setPaymentMethod("card")}
                            className={`flex-1 flex items-center justify-center py-2 px-4 rounded text-sm font-medium transition ${
                              paymentMethod === "card"
                                ? "bg-white shadow text-green-600"
                                : "text-gray-600 hover:text-gray-800"
                            }`}
                          >
                            <CreditCard className="w-5 h-5 mr-8 text-blue-600" />{" "}
                            Card
                          </button>
                          <button
                            type="button"
                            onClick={() => setPaymentMethod("ach")}
                            className={`flex-1 flex items-center justify-center py-2 px-4 rounded text-sm font-medium transition ${
                              paymentMethod === "ach"
                                ? "bg-white shadow text-green-600"
                                : "text-gray-600 hover:text-gray-800"
                            }`}
                          >
                            <Landmark className="w-5 h-5 mr-8 text-green-600" />{" "}
                            Bank Account
                          </button>
                        </div>
                      </div>

                      {/* Card Payment Fields */}
                      {paymentMethod === "card" && (
                        <div className="space-y-6">
                          {/* Card Number */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Card Number
                            </label>
                            <div className={`border px-3 py-2 rounded bg-white dark:bg-[#0F1729] ${errors.cardNumber ? "border-red-500" : "border-gray-300"}`}>
                              <CardNumberElement
                                options={{
                                  style: {
                                    base: {
                                      fontSize: "16px",
                                      color: isDarkMode ? "#fff" : "#000",
                                      "::placeholder": { color: "#a3a3a3" },
                                    },
                                  },
                                }}
                                onChange={(event) => {
                                  setTemptError(false);
                                  if (event.error) {
                                    setErrors((prev) => ({ ...prev, cardNumber: event.error.message }));
                                  } else {
                                    setErrors((prev) => ({ ...prev, cardNumber: "" }));
                                  }

                                }}
                              />
                            </div>
                            {/* {errors.cardNumber && (
                              <p className="small error color-danger mt-4">{errors.cardNumber}</p>
                            )} */}
                          </div>

                          {/* Expiry and CVC */}
                          <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                              <label className="text-sm font-medium">
                                Expiry Date
                              </label>
                              <div className={`border px-3 py-2 rounded bg-white dark:bg-[#0F1729] ${errors.cardExpiry ? "border-red-500" : "border-gray-300"}`}>
                                <CardExpiryElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: isDarkMode ? "#fff" : "#000",
                                        "::placeholder": { color: "#a3a3a3" },
                                      },
                                    },
                                  }}
                                  onChange={(event) => {
                                    setTemptError(false);
                                  if (event.error) {
                                    setErrors((prev) => ({ ...prev, cardExpiry: event.error.message }));
                                  } else {
                                    setErrors((prev) => ({ ...prev, cardExpiry: "" }));
                                  }
                                }}
                                />
                              </div>
                              {/* {errors.cardExpiry && (
                                <p className="small error color-danger mt-4">{errors.cardExpiry}</p>
                              )} */}
                            </div>
                            <div className="space-y-2">
                              <label className="text-sm font-medium">CVC</label>
                              <div className={`border px-3 py-2 rounded bg-white dark:bg-[#0F1729] ${errors.cardCvc ? "border-red-500" : "border-gray-300"}`}>
                                <CardCvcElement
                                  options={{
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                        color: isDarkMode ? "#fff" : "#000",
                                        "::placeholder": { color: "#a3a3a3" },
                                      },
                                    },
                                  }}
                                  onChange={(event) => {
                                    setTemptError(false);
                                  if (event.error) {
                                    setErrors((prev) => ({ ...prev, cardCvc: event.error.message }));
                                  } else {
                                    setErrors((prev) => ({ ...prev, cardCvc: "" }));
                                  }
                                }}

                                />
                              </div>
                              {/* {errors.cardCvc && (
                                <p className="small error color-danger mt-4">{errors.cardCvc}</p>
                              )} */}
                            </div>
                          </div>

                          {/* Name on Card */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Name on Card
                            </label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729]"
                              placeholder="John Doe"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>
                        </div>
                      )}

                      {/* ACH Payment Fields */}
                      {paymentMethod === "ach" && (
                        <div className="space-y-6">
                          {/* Routing Number */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Routing Number
                            </label>
                            <input
                              type="text"
                              className={`w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729] ${errors.routingNumber ? "border-red-500" : "border-gray-300"}`}
                              placeholder="123456789"
                              value={achDetails.routingNumber}
                              onChange={(e) =>{
                                setTemptError(false);
                                const val = e.target.value.replace(/\D/g, "").substring(0, 9);
                                setAchDetails((prev) => ({ ...prev, routingNumber: val }));
                               if (val.length === 9) {
                                setErrors((prev) => ({ ...prev, routingNumber: "" }));
                               } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  routingNumber: "Routing number must be 9 digits.",
                                }));
                              }}
                              }
                              maxLength="9"
                              required
                            />
                          </div>
                          {/* {errors.routingNumber && (
                            <p className="small error color-danger mt-4">{errors.routingNumber}</p>
                          )} */}


                          {/* Account Number */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Account Number
                            </label>
                            <input
                              type="text"
                              className={`w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729] ${errors.accountNumber ? "border-red-500" : "border-gray-300"}`}
                              placeholder="1234567890"
                              value={achDetails.accountNumber}
                              onChange={(e) => {
                                setTemptError(false);
                                const val = e.target.value.replace(/\D/g, "");

                                setAchDetails((prev) => ({ ...prev, accountNumber: val }));

                                if (val.length >= 4) {
                                  setErrors((prev) => ({ ...prev, accountNumber: "" }));
                                } else {
                                  setErrors((prev) => ({
                                    ...prev,
                                    accountNumber: "Account number must be at least 4 digits.",
                                  }));
                                }
                              }}
                              required
                            />
                          </div>
                          {/* {errors.accountNumber && (
                            <p className="small error color-danger mt-4">{errors.accountNumber}</p>
                          )} */}


                          {/* Account Type */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Account Type
                            </label>
                            <select
                              className="w-full px-3 py-2 border rounded text-sm bg-white dark:text-white dark:bg-[#0F1729]"
                              value={achDetails.accountType}
                              onChange={(e) =>
                                setAchDetails((prev) => ({
                                  ...prev,
                                  accountType: e.target.value,
                                }))
                              }
                              required
                            >
                              <option value="checking">Checking</option>
                              <option value="savings">Savings</option>
                            </select>
                          </div>

                          {/* Account Holder Name */}
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Account Holder Name
                            </label>
                            <input
                              type="text"
                              className={`w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729] ${errors.accountHolderName ? "border-red-500" : "border-gray-300"}`}
                              placeholder="John Doe"
                              value={achDetails.accountHolderName}
                               onChange={(e) => {
                                setTemptError(false);
                                const val = e.target.value;

                                setAchDetails((prev) => ({ ...prev, accountHolderName: val }));

                                if (val.trim().length > 0) {
                                  setErrors((prev) => ({ ...prev, accountHolderName: "" }));
                                } else {
                                  setErrors((prev) => ({
                                    ...prev,
                                    accountHolderName: "Account holder name is required.",
                                  }));
                                }
                              }}
                              required
                            />
                          </div>
                          {/* {errors.accountHolderName && (
                            <p className="small error color-danger mt-4">{errors.accountHolderName}</p>
                          )} */}


                          {/* ACH Notice */}
                          <div className="bg-blue-50 p-12 rounded text-sm text-blue-700 dark:bg-[#1A1F2C] dark:text-white dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] ">
                            <p className="font-medium">ACH Payment Notice:</p>
                            <p>• Processing takes 3-5 business days</p>
                            <p>• You may need to verify small deposits</p>
                            <p>• Lower processing fees apply</p>
                          </div>
                        </div>
                      )}

                      {/* Billing Address - Always Show */}
                      <div className="space-y-6">
                        <div className="space-y-2">
                          <label className="text-sm font-medium">Address</label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729]"
                            placeholder="123 Main St"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            required
                          />
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <label className="text-sm font-medium">City</label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729]"
                              placeholder="City"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />
                          </div>
                          <div className="space-y-2">
                            <label className="text-sm font-medium">State</label>
                            <div className="relative">
                              <select
                                className="w-full px-3 py-2 border bg-white rounded text-sm dark:text-white dark:bg-[#0F1729] appearance-none"
                                value={state}
                                onChange={(e) => setState(e.target.value)}
                                required
                              >
                                <option value="">Select State</option>
                                {US_STATES?.map((s) => (
                                  <option key={s?.value} value={s?.value}>
                                    {s?.label}
                                  </option>
                                ))}
                              </select>
                              <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-gray-500">
                                <svg
                                  className="h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path d="M5.25 7.75L10 12.5l4.75-4.75" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-2">
                          <label className="text-sm font-medium">
                            ZIP Code
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border rounded text-sm dark:text-white dark:bg-[#0F1729]"
                            placeholder="ZIP Code"
                            value={postalCode}
                            onChange={(e) => setPostalCode(e.target.value)}
                            required
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        disabled={loader}
                        className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 transition flex items-center flex-justify-center"
                      >
                        {loader ? (
                          <CircularProgress size={24} />
                        ) : (
                          <>
                            {paymentMethod === "card" ? (
                              <div className="flex items-center mr-10">
                                <CreditCard className="w-5 h-5 mr-2" />
                                <span>Pay with Card</span>
                              </div>
                            ) : (
                              <div className="flex items-center mr-10">
                                <Landmark className="w-5 h-5 mr-2" />
                                <span>Pay with Bank Account</span>
                              </div>
                            )}
                            {status === "trialing"
                              ? `${formatStripeAmount(
                                  plansDetail?.unit_amount
                                )}`
                              : !clientSecret?.amountToPay
                              ? `${formatStripeAmount(
                                  clientSecret?.finalAmountDue
                                )}`
                              : `${formatStripeAmount(
                                  clientSecret?.amountToPay
                                )}`}
                          </>
                        )}
                      </button>

                      <div className="flex items-center justify-center text-xs text-gray-600 mt-8">
                        <Shield className="w-4 h-4 mr-4" />
                        Payment secured with 256-bit SSL encryption
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.container}>
              <div className={styles.wrapper}>
                {/* Header */}
                <div className="mb-15 d-flex flex-justify-center">
                  <Button onClick={handleNavigateBack} className="pl-0">
                    <span
                      style={{ color: "#6B7280" }}
                      className="d-flex flex-center"
                    >
                      {" "}
                      <KeyboardBackspaceIcon
                        className="mr-8"
                        fontSize="small"
                      />
                      Back to Plans
                    </span>
                  </Button>
                </div>

                <div className={styles.header}>
                  <h2 className={styles.pageTitle}>Complete your purchase</h2>
                  <p className={styles.pageSubTitle}>
                    You're about to subscribe to the{" "}
                    {plansDetail?.product?.name}
                  </p>
                </div>
                {/* Grid Layout */}
                <div className={styles.grid2}>
                  {/* Order Summary */}
                  {clientSecret === null ? (
                    <div className={styles.card}>
                      <div className={styles.cardHeader}>Order Summary</div>
                      <div className={styles.cardContent}>
                        <div className={styles.data}>
                          <div className={styles.dataHeader}>
                            <div className={styles.planInfo}>
                              <p className={styles.newPlanText}>New Plan</p>
                              <p className={styles.planName}>
                                {plansDetail?.product?.name}
                              </p>
                              {status !== "trialing" && (
                                <span className={styles.upgradeBadge}>
                                  <ArrowUpwardOutlinedIcon
                                    fontSize="small"
                                    className={styles.upgradeIcon}
                                  />
                                  Upgrade
                                </span>
                              )}
                            </div>
                            <p className={styles.planAmount}>
                              {formatStripeAmount(plansDetail?.unit_amount)}
                            </p>
                          </div>

                          <div className={styles.adjustments}>
                            <h4 className={styles.adjustmentsTitle}>
                              Billing Adjustments
                            </h4>

                            {status === "trialing" ? (
                              <p className={styles.adjustmentText}>
                                Your first payment will be{" "}
                                {formatStripeAmount(plansDetail?.unit_amount)}.
                                {plansDetail?.recurring?.interval === "year" &&
                                  " This reflects annual billing with a 16.67% discount applied."}
                              </p>
                            ) : (
                              <div className={styles.adjustmentDetails}>
                                <p className={styles.adjustmentText}>
                                  Today, you'll get a pro-rated charge for the
                                  days remaining in this billing cycle. Starting
                                  from your next billing cycle, your account
                                  will be charged the full cost of your new
                                  subscription plan.
                                </p>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className={styles.orderRow}>
                          <span className={styles.planName}>
                            {plansDetail?.product?.name}
                          </span>
                          <span style={{ color: "#020817" }}>
                            {formatStripeAmount(plansDetail?.unit_amount)}
                          </span>
                        </div>

                        <div className={styles.billingCycle}>
                          <div className={styles.label}>Billing Cycle</div>
                          <div
                            className={`${styles.value} dark:text-[#6B7280] text-[#020817]`}
                          >
                            {plansDetail?.recurring?.interval === "month"
                              ? "Monthly"
                              : "Annual (Save 16.67%)"}
                          </div>
                        </div>

                        {plansDetail?.product?.name === "Users Plan" && (
                          <div className="mt-20">
                            <h4
                              className="mb-8"
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#020817",
                              }}
                            >
                              Number of Users :{" "}
                            </h4>
                            <div className="d-flex flex-center mt-1">
                              <input
                                id="numUsers"
                                type="number"
                                min="1"
                                value={numUsers}
                                onChange={(e) =>
                                  setNumUsers(parseInt(e.target.value) || 1)
                                }
                                style={{
                                  width: "90px",
                                  fontSize: "20px",
                                  fontWeight: "700",
                                  color: "#020817",
                                  border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                                  borderRadius: "4px",
                                }}
                              />
                              <span className="ml-15">
                                {numUsers} x{" "}
                                {price
                                  ? formatStripeAmount(price)
                                  : formatStripeAmount(
                                      plansDetail?.unit_amount
                                    )}{" "}
                                per user
                              </span>
                            </div>
                          </div>
                        )}

                        <div className={styles.totalSection}>
                          <div className={styles.totalRow}>
                            <span className={styles.totalLabel}>Total</span>
                            <span className={styles.totalPrice}>
                              {plansDetail?.product?.name === "Users Plan"
                                ? formatStripeAmount(
                                    (price || plansDetail?.unit_amount) *
                                      numUsers
                                  )
                                : !clientSecret?.amountToPay
                                ? `${formatStripeAmount(
                                    plansDetail?.unit_amount
                                  )}`
                                : `${formatStripeAmount(
                                    clientSecret?.amountToPay
                                  )}`}
                            </span>
                          </div>
                          <div className={styles.billingNote}>Billed Today</div>
                        </div>

                        <div className="mv-30 w-100">
                          <Button
                            onClick={handleQuantityStripeSubscription}
                            style={{ color: "white", backgroundColor: "green" }}
                            className="w-100"
                          >
                            Go To Pay{" "}
                            {plansDetail?.product?.name === "Users Plan"
                              ? formatStripeAmount(
                                  (price || plansDetail?.unit_amount) * numUsers
                                )
                              : `${formatStripeAmount(
                                  plansDetail?.unit_amount
                                )}`}
                          </Button>
                        </div>

                        <div className={styles.featuresList}>
                          <div className={styles.featureHeader}>
                            Plan includes:
                          </div>
                          {plansDetail?.product?.marketing_features?.map(
                            (feature, i) => (
                              <div key={i} className={styles.featureItem}>
                                <CheckOutlinedIcon
                                  className={styles.featureIcon}
                                />
                                <span>{feature?.name}</span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={styles.card}
                      style={{ width: "70%", height: "700px" }}
                    >
                      <div className={styles.cardHeader}>Payment Details</div>

                      <div className="d-flex flex-center flex-justify-center p-15">
                        <div
                          style={{
                            backgroundColor: "#F1F5F9",
                            padding: "10px",
                            borderRadius: "8px",
                          }}
                        >
                          <CreditCardOutlinedIcon
                            fontSize="large"
                            style={{ color: "blue" }}
                          />
                        </div>
                      </div>
                      <form
                        onSubmit={handleSubmit}
                        className="space-y-6 w-full max-w-md mx-auto"
                      >
                        {/* Card Number */}
                        <div className="space-y-2">
                          <label className="text-sm font-medium">
                            Card Number
                          </label>
                          <div className="border px-3 py-2 rounded bg-white">
                            <CardNumberElement
                              options={{
                                style: {
                                  base: {
                                    fontSize: "16px",
                                    color: isDarkMode ? "#fff" : "#000",
                                    "::placeholder": { color: "#a3a3a3" },
                                  },
                                },
                              }}
                            />
                          </div>
                        </div>

                        {/* Expiry and CVC */}
                        <div className="grid grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <label className="text-sm font-medium">
                              Expiry Date
                            </label>
                            <div className="border px-3 py-2 rounded bg-white">
                              <CardExpiryElement
                                options={{
                                  style: {
                                    base: {
                                      fontSize: "16px",
                                      color: isDarkMode ? "#fff" : "#000",
                                      "::placeholder": {
                                        color: isDarkMode
                                          ? "#0F1729"
                                          : "#a3a3a3",
                                      },
                                    },
                                  },
                                }}
                              />
                            </div>
                          </div>
                          <div className="space-y-2">
                            <label className="text-sm font-medium">CVC</label>
                            <div className="border px-3 py-2 rounded bg-white">
                              <CardCvcElement
                                options={{
                                  style: {
                                    base: {
                                      fontSize: "16px",
                                      color: isDarkMode ? "#fff" : "#000",
                                      "::placeholder": {
                                        color: isDarkMode
                                          ? "#0F1729"
                                          : "#a3a3a3",
                                      },
                                    },
                                  },
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Name on Card */}
                        <div className="space-y-2">
                          <label className="text-sm font-medium">
                            Name on Card
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border rounded text-sm"
                            placeholder="John Doe"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>

                        <div className="space-y-2">
                          <label className="text-sm font-medium">Address</label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border rounded text-sm"
                            placeholder="123 Main St"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            required
                          />
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <label className="text-sm font-medium">City</label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border rounded text-sm"
                              placeholder="City"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                              required
                            />
                          </div>
                          <div className="space-y-2">
                            <label className="text-sm font-medium">State</label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border rounded text-sm"
                              placeholder="State"
                              value={state}
                              onChange={(e) => setState(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-2">
                          <label className="text-sm font-medium">
                            ZIP Code
                          </label>
                          <input
                            type="text"
                            className="w-full px-3 py-2 border rounded text-sm"
                            placeholder="ZIP Code"
                            value={postalCode}
                            onChange={(e) => setPostalCode(e.target.value)}
                            required
                          />
                        </div>

                        {/* Pay Button */}
                        <button
                          type="submit"
                          disabled={loader}
                          className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
                        >
                          {loader ? (
                            <CircularProgress size={24} />
                          ) : !clientSecret?.amountToPay ? (
                            `Pay ${formatStripeAmount(
                              clientSecret?.finalAmountDue
                            )}`
                          ) : (
                            `Pay ${formatStripeAmount(
                              clientSecret?.amountToPay
                            )}`
                          )}
                        </button>

                        <div className="flex items-center justify-center text-xs text-gray-600 mt-8">
                          <Shield className="w-4 h-4 mr-4" />
                          Payment secured with 256-bit SSL encryption
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <PaymentSuccess
          handleNavigate={handleNavigate}
          plansDetail={plansDetail}
          paymentMethod={newPaymentMethod}
        />
      )}

      {paymentErrorPopup?.open === true && (
        <CommonSuccessDialog  
          open={paymentErrorPopup?.open}
          onClose={handleCloseDialog}
          title={"Payment Failed"}
          message={paymentErrorPopup?.message}
        />
      )}

      {messageDialog && (
          <Dialog open={messageDialog} maxWidth="sm" fullWidth>
            <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C]">
              <Typography variant="body" className="mt-25 dialogTitle dark:text-white">
                Bank Account Verification Pending
              </Typography>
            </div>

             <Divider className="mt-10" />

            <DialogContent
              className="mb-10 dark:bg-[#1A1F2C]"
              style={{ fontWeight: "600" }}
            >
              <div
                style={{ lineHeight: "22px", fontSize: "16px", marginTop: "16px" }}
                className="text-[#64748B] dark:text-[#F1F5F9]"
              >
                To complete the verification process, please follow the steps below:
                <br /><br />

                • Stripe will send two small micro-deposits (small amounts) to your bank account.
                <br />
                • These deposits typically arrive within 2–3 business days.
                <br />
                • Once you receive the deposits sent on behalf of ProTeams/Stripe in your bank statement, note the exact amounts.
                <br />
                • Return to this screen and enter both deposit amounts to verify your bank account.
                <br /><br />

                After your verification is successfully completed, your payment and
                subscription updates will be processed automatically.
              </div>
            </DialogContent>

            <DialogActions className="mt-20 mb-15 dark:bg-[#1A1F2C]">
              <Button
                variant="contained"
                style={{
                  backgroundColor: "green",
                  color: "white",
                  borderRadius: "5px",
                  padding: "8px 16px",
                }}
                onClick={() => handleCloseMessageDialog()}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
      )}
    </>
  );
};

export default PaymentFlowContet;
